import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import ProductDetails from './product-details';
import { MediaQuery as MQ } from '../../shared/media-query';
import { Suspense, lazy } from 'preact/compat';
const VipBenefits = lazy(
    () => import(/* webpackChunkName: "vip-benefits" */ '../shared/vip-benefits')
);
const SubscriptionButton = lazy(
    () => import(/* webpackChunkName: "subscription-button" */ '../shared/submit')
);

class Component extends BaseComponent {
    shouldComponentUpdate(nextProps) {
        if (nextProps.description != this.props.description) {
            return true;
        }

        if (nextProps.product != this.props.product) {
            return true;
        }

        return false;
    }

    render({ description, upc }) {
        if (description && description.code) {
            if (description.code == 'forecast-monthly-subscription') {
                return (
                    <subscription-teeup upc={upc}>
                        {this.renderVipContent()}
                    </subscription-teeup>
                );
            }

            return (
                <subscription-teeup upc={upc}>
                    <p className='price'>
                        {this.renderSalePrice()}
                        <span>{this.renderPrice()} Per Month</span>
                    </p>
                    <header>
                        <div className='icon-teeup' />
                        <h1 className='fancy-title'>{description.product_name}</h1>
                        <ProductDetails summary={description.subheader} details={description.long_description} />
                    </header>
                    <row className='is-wrap'>
                        <column className='is-3 is-12-mobile has-text-center has-margin-10-bottom has-padding-10'>
                            <img
                                className='icon'
                                alt='Daily Reflection Tarot Subscription Benefit 1'
                                src='https://gfx.tarot.com/images/subscriptions/drt/icon1.svg'
                            />
                            <br />
                            <h5>TRIPLE THE INSIGHT</h5>
                            <h5>
                                You’ll save over $140 every month by receiving three daily Tarot readings for the
                                price of one!
                            </h5>
                        </column>
                        <column className='is-3 is-12-mobile has-text-center has-margin-10-bottom has-padding-10'>
                            <img
                                className='icon'
                                alt='Daily Reflection Tarot Subscription Benefit 4'
                                src='https://gfx.tarot.com/images/subscriptions/drt/icon4.svg'
                            />
                            <br />
                            <h5>STAY ON TRACK</h5>
                            <h5>
                                Each reading is saved in your journal, so you can easily reflect on and track your
                                progress.
                            </h5>
                        </column>
                        <column className='is-3 is-12-mobile has-text-center has-margin-10-bottom has-padding-10'>
                            <img
                                className='icon'
                                alt='Daily Reflection Tarot Subscription Benefit 2'
                                src='https://gfx.tarot.com/images/subscriptions/drt/icon2.svg'
                            />
                            <br />
                            <h5>DAILY DOSE OF WISDOM</h5>
                            <h5>Set daily intentions and get quick insight on what’s happening in the moment.</h5>
                        </column>
                        <column className='is-3 is-12-mobile has-text-center has-margin-10-bottom has-padding-10'>
                            <img
                                className='icon'
                                alt='Daily Reflection Tarot Subscription Benefit 3'
                                src='https://gfx.tarot.com/images/subscriptions/drt/icon3.svg'
                            />
                            <br />
                            <h5>TAROT ON THE GO</h5>
                            <h5>Get insight anytime, anywhere! You can access your reading from any device.</h5>
                        </column>
                    </row>
                    <Suspense fallback={<div className='skeleton' />}>
                        <SubscriptionButton buttonText='PURCHASE SUBSCRIPTION' label='drts' upc={upc} />
                    </Suspense>
                </subscription-teeup>
            );
        }

        return (<subscription-teeup />);
    }

    mainExpandedVip = () => {
        if (this.props.upc == 'forecast-monthly-subscription') {
            const main = document.getElementsByTagName('main')[0];
            main.classList.add('expanded');
        }
    };

    renderVipContent = () => {
        return [
            this.renderTopImg(),
            <div className='vip-content-container'>
                <row className='is-justified-center has-text-center has-margin-5-mobile'>
                    <column>
                        <h1 className='fancy-title'>Become a VIP</h1>
                        <p>
                            Get an enhanced, personalized experience on Tarot.com! Here's what you'll get:
                        </p>
                    </column>
                </row>
                <Suspense fallback={<div className='skeleton' />}>
                    <VipBenefits upc={this.props.upc} />
                </Suspense>
                <Suspense fallback={<div className='skeleton' />}>
                    <SubscriptionButton buttonText='START MY FREE TRIAL*' label='vip-button' upc={this.props.upc} />
                </Suspense>
            </div>,
        ];
    }

    renderTopImg = () => {
        if (MQ.isMobile()) {
            return (
                <img
                    src='https://gfx.tarot.com/images/site/membership/vip-header-m.jpg'
                    className='is-visible-mobile is-full-width'
                    height='160'
                    width='1200'
                    loading='lazy'
                    alt='Vip membership banner image'
                />
            );
        }

        return (
            <img
                src='https://gfx.tarot.com/images/site/membership/vip-header-d.jpg'
                className='is-hidden-mobile is-full-width'
                height='104'
                width='380'
                loading='lazy'
                alt='Vip membership banner image'
            />
        );
    };

    renderSalePrice = () => {
        if (this.props.product.price && this.props.product.price.usd.current < this.props.product.price.usd.original) {
            return (<s>${this.props.product.price.usd.original.toFixed(2)}</s>);
        }

        return null;
    }

    renderPrice = () => {
        if (this.props.product.price) {
            return `$${this.props.product.price.usd.current.toFixed(2)}`;
        }

        return null;
    }
}

const mapStateToProps = (state) => ({
    description: state.product && state.product.description,
    product: state.product,
});

export default connect(mapStateToProps)(Component);
